import { IComponentOptions, IController } from 'angular';

class TestModalController implements IController {
  public data: any;
  public onClose: ( $event ) => void;

  public closeModal() {
    this.onClose({ result: 'this is result' });
  }
}

export const TestModalComponent: IComponentOptions = {
  controller: TestModalController,
  template: require('./test-modal.component.html'),
  bindings: {
    data: '<',
    onClose: '&'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/test-modal/test-modal.component.ts